import {
    CssBaseline,
    ThemeProvider,
    StyledEngineProvider,
} from "@mui/material";
import "styles/index.css";
import {store, persistor} from "redux/store";
import theme from "config/theme/theme";
import authRoutes from "config/authRoutes";
import {Provider} from "react-redux";
import Toaster from "components/Toaster";
import {jss} from "localization/index";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {StylesProvider} from "@mui/styles";
import RoutesBuilder from "components/routesBuilder";
import SessionWrapper from "components/SessionWrapper";
import CustomBackdrop from "components/CustomBackdrop";
import {PersistGate} from "redux-persist/integration/react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "./components/Spinner";
import ZohoChatBot from "./pages/zoho/ZohoChatBot";

// see Deprecated ** Remove <StylesProvider jss={jss}>
function App() {
    return (
        <StyledEngineProvider injectFirst>
            <StylesProvider jss={jss}>
                <ThemeProvider theme={theme}>
                    <CssBaseline/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Provider store={store}>
                            <PersistGate loading={<Spinner/>} persistor={persistor} onBeforeLift={() =>
                                new Promise((resolve) => setTimeout(resolve, 1000)) // 1 sec delay
                            }>
                                <SessionWrapper>
                                    <ZohoChatBot/>
                                    <RoutesBuilder/>
                                    {/*<RouterProvider router={router} />*/}
                                    <Toaster/>
                                    <ToastContainer/>
                                    {/*<CustomBackdrop/>*/}
                                </SessionWrapper>
                            </PersistGate>
                        </Provider>
                    </LocalizationProvider>
                </ThemeProvider>
            </StylesProvider>
        </StyledEngineProvider>
    );
}

export default App;
